import appConfig from '@/config';

import Base from './base.js';

import FrontendParams from '@/models/list/frontend-params.js';
import { localeFormatDefault } from '@/plugins/date-print';
import { EVENT_PAY_TYPES } from '@/modules/Moderation/constants';
import { EVENT_DIRECTIONS_DATA, EVENT_OPTIONS_AGES, EVENT_STAGE_FORMAT } from '@/modules/Events/constants.js';
import { dateFnsFormat } from '@/helpers/dateFns';

export default class EventOptions extends Base {
  #currentDate;

  constructor(item = {}, url) {
    super(item, url);

    this.directory_event_member_type = {
      id: null,
      name: null,
    };
    this.event_member_type = item.event_member_type;
    this.start_accepting_at = localeFormatDefault(item.start_accepting_at);
    this.end_accepting_at = localeFormatDefault(item.end_accepting_at);
    this.rules = item.rules;
    this.is_certificate_required = item.is_certificate_required ?? false;
    this.association_membership_requirement = item.association_membership_requirement ?? null;
    this.project_id = item.project_id;
    this.can_subordinate = item.can_subordinate;
    this.max_participants = item.max_participants;
    this.directory_event_member_type_ids = item.directory_event_member_type_ids || [];
    this.frontend_params = new FrontendParams(item.frontend_params || {});
    this.has_nominations = item.has_nominations || false;
    this.directory_direction_id = item.directory_direction_id;
    this.event_type = item.event_type;
    this.is_without_moderation = item.is_without_moderation || false;
    this.prize_place_count = item.prize_place_count || 0;
    this.is_limited_members = item.is_limited_members || false;
    this.pay_type = item.pay_type || EVENT_PAY_TYPES.FREE;
    this.price = item.price || '';
    this.min_participants_per_team = item.min_participants_per_team || 0;
    this.max_participants_per_team = item.max_participants_per_team || 0;
    this.member_old_type = item.member_old_type || null;
    this.is_for_trainers = item.is_for_trainers || false;
    this.is_without_stages = item.is_without_stages || false;
    this.directory_event_type_item_ids = !Array.isArray(item.directory_event_type_item_ids)
      ? []
      : item.directory_event_type_item_ids || [];
    this.is_olympics = item.is_olympics || false;
    this.is_manual_group_management = item.is_manual_group_management || false;

    this.directory_event_requirement_ids = item.directory_event_requirement_ids || [];
    this.search_visible = item.search_visible || false;
    this.is_hide_members = item.is_hide_members || false;

    this.min_age = item.min_age ?? EVENT_OPTIONS_AGES.min;
    this.max_age = item.max_age ?? EVENT_OPTIONS_AGES.max;
    this.use_age_limit = item.use_age_limit;

    this.format = item.format ?? EVENT_STAGE_FORMAT.fulltime;

    if (item.directory_event_member_type_ids) {
      const [type] = item.directory_event_member_type_ids;
      this.directory_event_member_type.id = type;
      this.directory_event_member_type.name = appConfig.EVENT_OLD_TYPE_TEXT[type];
    }

    this.#currentDate = new Date();

    // Права для шаблонов (event.status === 10);
    this.is_created_groups = item.is_created_groups ?? true;
    this.is_created_attributes = item.is_created_attributes ?? true;
    this.is_created_polls = item.is_created_polls ?? true;
    this.is_created_experts = item.is_created_experts ?? true;
    this.is_create_tournament_many_rounds = item.is_create_tournament_many_rounds ?? true;
  }

  get isRegisterNotStart() {
    const startRegisterDate = dateFnsFormat.parseDate(this.start_accepting_at);
    return !!startRegisterDate && this.#currentDate < startRegisterDate;
  }

  get isRegisterEnd() {
    const endRegisterDate = dateFnsFormat.parseDate(this.end_accepting_at);
    return !endRegisterDate || this.#currentDate > endRegisterDate;
  }

  get isRegisterPeriod() {
    return !this.isRegisterNotStart && !this.isRegisterEnd;
  }

  updateFrontendParams(params) {
    const { frontend_params } = this;
    return this.update({
      data: {
        frontend_params: {
          ...frontend_params,
          ...params,
        },
      },
    }).then((response) => {
      this.frontend_params = new FrontendParams(this.frontend_params || {});
      return response;
    });
  }

  get directionData() {
    return EVENT_DIRECTIONS_DATA[this.directory_direction_id];
  }
}
